import React from 'react';
import ManageOrders from '../../features/orders/ManageOrders';
import ManageVanOrders from '../../features/vanuser/VanOrdersManage';
import ManageWholesaleInventory from '../../features/wholesaleinventory/ManageWholesaleInventory';
export default function HomeRedirect() {
    const auth = JSON.parse(localStorage.getItem('token'));
    const usertype = auth?.usertype;
  
    if (usertype === 'van') {
      return <ManageVanOrders />;
    } 
    else if (usertype === 'wholesaleuser') {
      return <ManageWholesaleInventory />;
    } 
    else {
      return <ManageOrders />;
    }
  }
